/** Legacy localStorage keys used by WalletPluginEmbedded (migration reads these). */
export const EMBEDDED_WALLET_STORAGE_KEY = 'pc_embedded_wallet'
export const EMBEDDED_WALLET_PASSWORD_SESSION_KEY = 'pc_embedded_wallet_password'
